import AppRoute from "./routes/AppRoute";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  
    return <AppRoute />;
  
}

export default App;
